type AuthProvider {
  id: ID!
  name: String
  mechanism: String
  redirect_url: String
  active: Boolean
}

input AuthProviderInput {
  authentication_name: String
  authentication_mechanism: String
  redirect_url: String
  active: Boolean
}
